(function() {
    'use strict';
    angular
        .module('liverunApp')
        .factory('Race', Race);

    Race.$inject = ['$resource', 'DateUtils'];

    function Race ($resource, DateUtils) {
        var resourceUrl =  'api/races/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertDateTimeFromServer(data.date);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                        data.finishDate = DateUtils.convertDateTimeFromServer(data.finishDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
